export const generateSideNavSettingsConfig = (userData) => ({
  body: [
    {
      name: 'Home',
      icon: 'home',
      link: '/app/merchant/#/dashboard'
    },
    {
      name: 'Orders',
      icon: 'orders',
      children: [
        {
          name: 'All Orders',
          link: userData.featureFlags?.['GSCT.ODM.IsNewOrdersUIDefault'] ? '/app/merchant/#/order-shipment-management/orders' : '/app/merchant/#/orders'
        },
        {
          name: 'Work Orders',
          link: '/app/merchant/#/inventory/work-orders'
        },
        {
          name: 'Rules',
          link: '/app/merchant/#/order-shipment-management/rules'
        },
        {
          name: 'Customers',
          link: '/app/merchant/#/Customers'
        }
      ]
    },
    {
      name: 'Products',
      icon: 'products',
      link: userData.customerPreferences?.NewProductCatalogEnabled ? '/app/merchant/#/product-catalog' : '/App/IndexV2/#/Products'
    },
    {
      name: 'Inventory',
      icon: 'inventory',
      children: [
        {
          name: 'Inventory Status',
          link: userData.featureFlags?.InventoryStatusPageMFE ? '/app/merchant/#/inventory-status' : '/app/merchant/#/inventory/all'
        },
        {
          name: 'Inventory History',
          link: '/App/IndexV2/#/InventoryHistory'
        },
        {
          name: 'Inventory Transfers',
          link: userData.customerPreferencs?.NewInventoryUIEnabled ? '/app/merchant/#/inventory-transfers' : '/App/IndexV2/#/InventoryTransfer'
        },
        {
          name: 'Inventory Distribution',
          link: '/app/merchant/#/Locations/Inventory'
        },
        {
          name: 'Fulfillment Centers',
          link: '/app/merchant/#/Locations/Access'
        }
      ]
    },
    {
      name: 'Receiving',
      icon: 'receiving',
      children: [
        {
          name: 'Receiving Orders',
          link: '/app/merchant/#/inventory/receiving/all'
        },
        {
          name: 'On Hold Receiving',
          link: '/App/IndexV2/#/OnHoldReceiving'
        }
      ]
    },
    {
      name: 'Returns',
      icon: 'returns',
      link: '/app/merchant/#/returns/all'
    },
    {
      name: 'Pricing',
      icon: 'pricing',
      link: '/app/merchant/#/Pricing'
    },
    {
      name: 'Finances',
      icon: 'billing',
      children: [
        {
          name: 'Billing',
          link: '/app/merchant/#/Billing'
        },
        {
          name: 'Payment Methods',
          link: '/app/merchant/#/Payment'
        },
        {
          name: 'ShipBob Capital',
          link: '/app/merchant/#/Payment/Capital'
        }
      ]
    },
    {
      name: 'Analytics',
      icon: 'analytics',
      link: '/app/merchant/#/analytics/list'
    },
    {
      name: 'Integrations',
      icon: 'integrations',
      children: [
        {
          name: 'App Store',
          link: '/app/merchant/#/Integrations/Store'
        },
        {
          name: 'My Apps',
          link: '/app/merchant/#/Integrations/MyApps'
        },
        {
          name: 'Store Management',
          link: '/UserDetails/#/StoreManagement'
        },
        {
          name: 'Manage Badges',
          link: '/app/merchant/#/2DayShippingBadges'
        },
        {
          name: 'API Tokens',
          link: '/app/merchant/#/Integrations/token-management'
        },
        {
          name: 'OAuth Apps',
          link: '/app/merchant/#/Integrations/app-management'
        },
        {
          name: 'Webhooks',
          link: '/app/merchant/#/Integrations/webhooks'
        },
        {
          name: 'API Settings',
          link: '/UserDetails/#/API'
        }
      ]
    },
    {
      type: 'separator'
    },
    {
      name: 'Settings',
      icon: 'settings',
      type: 'popover',
      children: [
        {
          name: 'Settings',
          type: 'title'
        },
        {
          type: 'separator'
        },
        {
          name: 'Account & User Management',
          type: 'subTitle'
        },
        {
          name: 'My Profile',
          icon: 'profile',
          link: '/app/merchant/#/user-management/my-profile'
        },
        {
          name: 'Company Profile',
          icon: 'company',
          link: '/app/merchant/#/user-management/company-profile'
        },
        {
          name: 'User Management',
          icon: 'manage',
          link: '/app/merchant/#/user-management'
        },
        {
          name: 'Email Notifications',
          icon: 'email',
          link: '/UserDetails/#/EmailNotifications'
        },
        {
          name: 'Manage Subaccounts',
          icon: 'account',
          link: '/app/merchant/#/user-management/account-management'
        },
        {
          name: 'Shipment Management',
          type: 'subTitle'
        },
        {
          name: 'Ship Option Mapping',
          icon: 'mapping',
          link: userData?.featureFlags?.['Transportation.EnableNewShipOptionUserMapping'] ? '/app/merchant/#/labeling/ship-option-mapping' : '/UserDetails/#/shipOptionMapping'
        },
        {
          name: 'Shipment Settings',
          icon: 'shipment',
          link: '/UserDetails/#/shipmentSettings'
        },
        {
          name: 'Customize Packing Slip',
          icon: 'slip',
          link: '/app/merchant/#/fulfillment-settings/packaging-slip'
        },
        {
          name: 'Gift Notes',
          icon: 'gift',
          link: '/app/merchant/#/Giftnotes/Signup'
        },
        {
          name: 'Custom Document Settings',
          icon: 'gift',
          link: '/app/merchant/#/fulfillment-settings/custom-order-documents'
        },
        {
          name: 'Activity Log',
          icon: 'activity',
          link: '/ActivityLog/'
        }
      ]
    }
  ],
  footer: [
    {
      name: 'Logout',
      icon: 'logout-icon',
      link: '/app/merchant/#/Logout'
    }
  ]
})
